module.exports = __webpack_public_path__ + "static/media/032-video-call-1.e4db7a1f.svg";